import { useMarkdownToHtml } from '@/hooks/useMarkdownToHtml';

interface MarkdownTextProps {
  markdown: string;
  className?: string;
}

export const MarkdownText = ({ markdown, className }: MarkdownTextProps) => {
  const { html, error } = useMarkdownToHtml(markdown);
  if (error || !html) {
    return <div className={className}>{markdown}</div>;
  }
  return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};
